export const reducer = (state, action) => {
  switch (action.type) {
    case "set_products":
      return {
        ...state,
        products: action.payload,
      };

    default:
      return state;
  }
};

export const initialState = {
  products: [],
};
